import { createApi, fetchBaseQuery }  from '@reduxjs/toolkit/query/react'

//define a service

const appApi = createApi({
    reducerPath: 'appApi',
    baseQuery: fetchBaseQuery({
        baseUrl: 'https://chatterboxx-backend.herokuapp.com/'
    }),
    endpoints: (builder) => ({
        //register a user
        registerUser: builder.mutation({
            query: (user) => ({
                url:  '/api/user/register',
                method: 'POST',
                body: user
            })
        }),
        //login a user
        loginUser: builder.mutation({
            query: (user) => ({
                url: '/api/user/login',
                method: 'POST',
                body: user
            }),
        }),
        //logout user
        logoutUser: builder.mutation({
            query: (payload) => ({
                url: '/logout',
                method: 'DELETE',
                body: payload
            }),
        }),
    })
})

export const { useLoginUserMutation, useLogoutUserMutation, useRegisterUserMutation } = appApi

export default appApi